import React, { Component, Fragment } from 'react'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { contentActions, messageActions } from '../../../actions'
import TextField from '@material-ui/core/TextField'
import SelectWrapped from '../../../components/SelectWrapped'
import { formatContentSelectValue, filterOptionsFunction } from '../../../utils'
import Typography from '@material-ui/core/Typography'
import * as API from '../../../api'
import Button from '@material-ui/core/Button'
import FileUpload from 'material-ui/svg-icons/file/file-upload'
import { CodigoArtigoField, DateField } from '../../../components/Fields'
import { readOnly } from '../../../utils/permissions'
import EditIcon from 'material-ui/svg-icons/image/edit'
import EditDocumentModal from '../EditDocumentModal'

const styles = theme => ({
  layout: {
    height: 'calc(100% - 64px)',
    position: 'relative'
  },
  contentForm: {
    background: '#fff',
    height: '100%',
    boxSizing: 'border-box',
    padding: theme.spacing.unit * 3,
    overflow: 'auto'
  },
  formGroup: {
    padding: '12px 0'
  },
  formControl: {
    margin: '12px 0'
  },
  uploadButton: {
    margin: '15px 0',
    padding: '0 16px',
    background: 'rgb(0, 45, 114)',
    color: '#fff'
  },
  uploadButtonIcon: {
    color: 'inherit !important',
    marginLeft: '3px'
  },
  editButton: {
    margin: '15px 0',
    marginLeft: '10px',
    padding: '0 16px',
    background: 'rgb(0, 45, 114)',
    color: '#fff'
  },
  uploadButtonIcon: {
    color: 'inherit !important',
    marginLeft: '3px'
  }
})

class Diretriz extends Component {
  handleChangeFile = e => {
    e.preventDefault()
    const { handleChangeContent, content, getHtmlPreview, changeMessage } = this.props

    let [file] = e.target.files

    if (file) {
      handleChangeContent({
        ...content,
        document: file || ''
      })
      getHtmlPreview({ document: file })
        .then(response => {
          changeMessage({ message: 'Pré-visualização carregada com sucesso.' })
        })
        .catch(error => {
          const { response = {} } = error
          const { status } = response
          if (status === 400) {
            changeMessage({ message: 'Formato de arquivo inválido.' })
          }
        })
    } else {
      handleChangeContent({
        ...content,
        document: file || ''
      })
    }
  }
  componentDidMount() {
    this.props.removeHtmlDocument()
  }
  render() {
    const {
      classes,
      content,
      handleChangeContent,
      contentFormErrors,
      formTouched,
      removeHtmlDocument,
      token,
      openEditDocumentModal
    } = this.props

    const { handleChangeFile } = this

    const isReadOnly = readOnly(content.tipo, token)

    return (
      <Fragment>
        <div>
          <input type="file" id="upload" style={{ display: 'none' }} onChange={handleChangeFile} />
          {!!content.document && (
            <Button
              small
              onClick={() => {
                removeHtmlDocument()
              }}
              color={'secondary'}
              disabled={isReadOnly}
            >
              Remover
            </Button>
          )}
          <Button
            htmlFor="upload"
            component={'label'}
            variant="raised"
            color={'primary'}
            className={classes.uploadButton}
            disabled={isReadOnly}
          >
            Upload HTML <FileUpload className={classes.uploadButtonIcon} />
          </Button>
          <Button
            onClick={() => openEditDocumentModal()}
            component={'label'}
            variant="raised"
            color={'primary'}
            className={classes.editButton}
            disabled={isReadOnly}
          >
            Editar <EditIcon className={classes.uploadButtonIcon} />
          </Button>
          {!((contentFormErrors.fields || {})['document'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['document'] || {}).errorMessage}
            </Typography>
          ) : null}
        </div>
        <FormControl
          error={!((contentFormErrors.fields || {})['titulo'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-titulo">Título</InputLabel>
          <Input
            fullWidth
            required={'required'}
            type="text"
            onChange={e => {
              handleChangeContent({ ...content, titulo: e.target.value })
            }}
            value={content.titulo}
            id="field-titulo"
            disabled={isReadOnly}
          />
          {!((contentFormErrors.fields || {})['titulo'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['titulo'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <FormControl
          error={!((contentFormErrors.fields || {})['subtitulo'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-subtitulo">Subtítulo</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            onChange={e => {
              handleChangeContent({ ...content, subtitulo: e.target.value })
            }}
            value={content.subtitulo}
            id="field-subtitulo"
          />
          {!((contentFormErrors.fields || {})['subtitulo'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['subtitulo'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <FormControl
          error={!((contentFormErrors.fields || {})['autoresDiretriz'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-autoresDiretriz">Autores</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            onChange={e => {
              handleChangeContent({ ...content, autoresDiretriz: e.target.value })
            }}
            value={content.autoresDiretriz}
            id="field-autoresDiretriz"
          />
          {!((contentFormErrors.fields || {})['autoresDiretriz'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['autoresDiretriz'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <FormControl
          error={!((contentFormErrors.fields || {})['instituicao'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-instituicao">Instituição</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            onChange={e => {
              handleChangeContent({ ...content, instituicao: e.target.value })
            }}
            value={content.instituicao}
            id="field-instituicao"
          />
          {!((contentFormErrors.fields || {})['instituicao'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['instituicao'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <FormControl
          error={!((contentFormErrors.fields || {})['codigo'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-codigo">Código da diretriz</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            inputComponent={CodigoArtigoField}
            onChange={e => {
              handleChangeContent({ ...content, codigo: e.target.value })
            }}
            value={content.codigo || ''}
            id="field-codigo"
          />
          {!((contentFormErrors.fields || {})['codigo'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['codigo'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <div className={classes.formControl}>
          <TextField
            disabled={isReadOnly}
            fullWidth
            onChange={obj => {
              handleChangeContent({ ...content, palavrasChave: obj })
            }}
            error={!((contentFormErrors.fields || {})['palavrasChave'] || {}).valid && formTouched}
            value={formatContentSelectValue(content.palavrasChave || [])}
            placeholder="Selecione..."
            name="react-select-chip-keywords"
            label="Palavras-chave"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              inputComponent: SelectWrapped,
              inputProps: {
                multi: true,
                filterOptions: filterOptionsFunction,
                instanceId: 'react-select-chip-label',
                id: 'react-select-chip-keywords',
                loadOptions: API.keywords.getSelectKeywords,
                disableDelete: isReadOnly
              }
            }}
          />
          {!((contentFormErrors.fields || {})['palavrasChave'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['palavrasChave'] || {}).errorMessage}
            </Typography>
          ) : null}
        </div>
        <FormControl
          error={!((contentFormErrors.fields || {})['dataPublicacao'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-dataPublicacao">Data de publicação</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            inputComponent={DateField}
            onChange={e => {
              handleChangeContent({ ...content, dataPublicacao: e.target.value })
            }}
            value={content.dataPublicacao || ''}
            id="field-dataPublicacao"
          />
          {!((contentFormErrors.fields || {})['dataPublicacao'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['dataPublicacao'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <EditDocumentModal content={content} handleChangeContent={handleChangeContent} />
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    content: state.content.content,
    contentFormErrors: state.content.contentFormErrors,
    formTouched: state.content.contentFormTouched,
    conteudoHtml: state.content.conteudoHtml,
    token: state.auth.token
  }
}
const mapDispatchToProps = dispatch => {
  return {
    handleChangeContent: content => {
      dispatch(contentActions.handleChangeContent(content))
    },
    setContentFormTouched: () => {
      return dispatch(contentActions.setContentFormTouched())
    },
    removeHtmlDocument: () => {
      return dispatch(contentActions.removeHtmlDocument())
    },
    getHtmlPreview: content => {
      return dispatch(contentActions.getHtmlPreview(content))
    },
    changeMessage: ({ message, anchorOrigin }) => {
      dispatch(messageActions.changeMessage({ message, anchorOrigin }))
    },
    openEditDocumentModal: () => {
      dispatch(contentActions.openEditDocumentModal())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(Diretriz))



// WEBPACK FOOTER //
// ./src/containers/Content/ContentTypes/Diretriz.js